(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["hw-bundle-picker"] && !Shopify.designMode) return;
  try {
    class HwBundleQty extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', (event) => {
        const input = event.target;
        if (!(input instanceof HTMLInputElement)) return;
        const qty = parseInt(input.dataset.hwQty || '1', 10);
        this.syncQuantity(qty);
      });
      // Sync the initially-checked card on load; if the configured default
      // card isn't rendered, fall back to the first card.
      let checked = this.querySelector('input:checked');
      if (!checked) {
        checked = this.querySelector('input[type="radio"]');
        if (checked) checked.checked = true;
      }
      if (checked) this.syncQuantity(parseInt(checked.dataset.hwQty || '1', 10));
    }

    syncQuantity(qty) {
      const scope = this.closest('.shopify-section') || document;
      const qtyInput = scope.querySelector('quantity-selector-component input[name="quantity"]');
      if (!qtyInput) return;
      if (parseInt(qtyInput.value, 10) === qty) return;
      qtyInput.value = String(qty);
      // Trigger Horizon's own handler (bound to blur) so the
      // QuantitySelectorUpdateEvent propagates to ATC button + sticky bar.
      qtyInput.dispatchEvent(new Event('blur', { bubbles: true }));
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  if (!customElements.get('hw-bundle-qty')) {
    customElements.define('hw-bundle-qty', HwBundleQty);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["hw-rating"] && !Shopify.designMode) return;
  try {
    if (!window.__hwRatingScroll) {
    window.__hwRatingScroll = true;
    document.addEventListener('click', (event) => {
      const link = event.target.closest('[data-hw-rating]');
      if (!link) return;
      const href = link.getAttribute('href') || '';
      if (!href.startsWith('#')) return;
      const target = document.querySelector(href);
      if (target) {
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["hw-review-card"] && !Shopify.designMode) return;
  try {
    class HwReviewCard extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-hw-rc-track]');
      this.dotsContainer = this.querySelector('[data-hw-rc-dots]');
      if (!this.track || !this.dotsContainer) return;

      const slides = Array.from(this.track.children);
      if (slides.length < 2) {
        this.dotsContainer.remove();
        return;
      }

      slides.forEach((slide, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'hw-review-card__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Go to review ' + (i + 1));
        dot.addEventListener('click', () => {
          this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
        });
        this.dotsContainer.appendChild(dot);
      });

      this.dots = Array.from(this.dotsContainer.children);
      this.track.addEventListener(
        'scroll',
        () => {
          if (this._raf) return;
          this._raf = window.requestAnimationFrame(() => {
            this._raf = null;
            this.updateDots();
          });
        },
        { passive: true }
      );
    }

    updateDots() {
      const slides = Array.from(this.track.children);
      const center = this.track.scrollLeft + this.track.clientWidth / 2;
      let active = 0;
      let best = Infinity;
      slides.forEach((slide, i) => {
        const c = slide.offsetLeft - this.track.offsetLeft + slide.offsetWidth / 2;
        const d = Math.abs(c - center);
        if (d < best) {
          best = d;
          active = i;
        }
      });
      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === active));
    }
  }

  if (!customElements.get('hw-review-card')) {
    customElements.define('hw-review-card', HwReviewCard);
  }
  } catch(e) { console.error(e); }
})();

})();
